import { create } from 'zustand';
import { devtools, persist, createJSONStorage } from 'zustand/middleware';
import { ICardActionData, ICategoryList, IMetadata, IPlayListDetail } from '@ninjacart/nc-nk-core'
import { MMKVStoreKeyMap } from '../mmkv/mmkvStoreKeyMap';
import { zustandDiscoveryStore } from '../mmkv/mmkvDiscoveryPersistence';

type DiscoveryStore = {
    discoveryFeeds: Array<IMetadata>;
    setDiscoveryFeeds: (payload: Array<IMetadata>) => void;
    selectedDiscoveryFeed: ICardActionData;
    selectedDiscoveryFeedList: IMetadata;
    selectedDiscoveryFeedType: string;
    discoveryFeedPlayList: IPlayListDetail;
    selectedPlayListDetailList: IPlayListDetail;
    eventDiscoveryFeedType: string;
    activeFeedItemIndex: number;
    setSelectedDiscoveryFeed: (payload?: ICardActionData) => void;
    setSelectedDiscoveryFeedList: (payload: IMetadata) => void;
    setSelectedDiscoveryFeedType: (payload: string) => void;
    setDiscoveryFeedPlayList: (payload: IPlayListDetail) => void;
    setSelectedPlayListDetailList: (payload: IPlayListDetail) => void;
    setEventDiscoveryFeedType: (payload: string) => void;
    setActiveFeedItemIndex: (index: number) => void;
    selectedCategory: ICategoryList;
    setSelectedCategory: (payload: ICategoryList) => void;
};

export const useDiscoveryStore = create<DiscoveryStore>()(
    persist(
        (set, get) => ({
            discoveryFeeds: [],
            setDiscoveryFeeds: (discoveryFeeds: Array<IMetadata>) =>
                set((state) => ({ discoveryFeeds: [...state.discoveryFeeds, ...discoveryFeeds] })),
            selectedDiscoveryFeed: {
                contentType: '',
                content: {
                    videoTitle: '',
                    authorName: '',
                    viewCount: 0,
                    videoLink: '',
                    name: '',
                    videoCount: 0,
                    mediaDetails: [],
                },
                mediaDetails: [],
                eventNamePrefix: '',
            },
            selectedDiscoveryFeedType: '',
            selectedDiscoveryFeedList: {
                type: '',
                cardDetails: {
                    name: '',
                },
                mediaDetails: [],
                actionData: [],
                eventNamePrefix: '',
                createdByType: '',
                geoLocation: {},
                language: '',
                regions: [],
                permissions: [],
            },
            discoveryFeedPlayList: {
                total: 0,
                data: [],
            },
            selectedPlayListDetailList: {
                total: 0,
                data: [],
            },
            activeFeedItemIndex: -1,
            eventDiscoveryFeedType: '',
            selectedCategory: {
                categoryName: '',
                filters: [],
                seoCategoryName: '',
            },
            setActiveFeedItemIndex: (index: number) => set(() => ({ activeFeedItemIndex: index })),
            setSelectedDiscoveryFeed: (selectedDiscoveryFeed?: ICardActionData) =>
                set((state) => ({ selectedDiscoveryFeed: selectedDiscoveryFeed })),
            setSelectedDiscoveryFeedType: (selectedDiscoveryFeedType: string) =>
                set((state) => ({ selectedDiscoveryFeedType: selectedDiscoveryFeedType })),
            setSelectedDiscoveryFeedList: (selectedDiscoveryFeedList: IMetadata) =>
                set((state) => ({ selectedDiscoveryFeedList: selectedDiscoveryFeedList })),
            setDiscoveryFeedPlayList: (discoveryFeedPlayList: IPlayListDetail) =>
                set((state) => ({ discoveryFeedPlayList: discoveryFeedPlayList })),
            setSelectedPlayListDetailList: (playListDetailList: IPlayListDetail) =>
                set((state) => ({
                    ...state,
                    selectedPlayListDetailList: playListDetailList,
                })),
            setEventDiscoveryFeedType: (eventDiscoveryFeedType: string) =>
                set((state) => ({ eventDiscoveryFeedType: eventDiscoveryFeedType })),
            setSelectedCategory: (selectedCategory: ICategoryList) =>
                set((state) => ({ selectedCategory: selectedCategory })),
        }),
        {
            name: MMKVStoreKeyMap.discoveryStore,
            storage: createJSONStorage(() => zustandDiscoveryStore),
            partialize: (state) => ({
                selectedCategory: state.selectedCategory,
            }),
        }
    )
);
